module.exports = __webpack_public_path__ + "static/media/AreaMeasurement_001.189970ab.jpg";